export class TimePicker {

   constructor(settings) {

      this.elMain = HTMLElement.createFromHTML(`
         <div class="time-picker" style="display: inline-block;">
            <div class="digital" style="text-align: center; font-size: 4rem;"></div>
            <div class="select">
               <canvas style="width: 100%;"></canvas>
            </div>
         </div>
      `);

      this.elDigital = this.elMain.querySelector('.digital');
      this.elCanvas = this.elMain.querySelector('canvas');
      this.ctx = this.elCanvas.getContext('2d');

      this.dragging = false;
      
      this.setup(settings);
      this.initDragging();			

   }
   
   setup(settings) {

      this.settings = Object.assign({
         size: 400,
         minuteCircleColor: '#3A78FF',
         hourCircleColor: '#3A78FF',
         hourCircleColor2: '#3A78FF',
         centerCircleColor: '#3A78FF',
         hourNumberColor: '#000000',
         hourNumberColor2: '#000000',
         minuteNumberColor: '#000000',
         selectedColor: '#ff0000',
         onSelect: false
      }, settings);

      if (this.settings.initTime) {
         this.hour = this.settings.initTime.hour;
         this.minute = this.settings.initTime.minute;
      }
      else {
         const date = new Date();
         this.hour = date.getHours();
         this.minute = date.getMinutes();
      }


      this.elCanvas.width  = this.settings.size;
      this.elCanvas.height = this.settings.size;
      this.radius = this.settings.size / 2;
   
   }
   
   initDragging() {
      this.elCanvas.addEventListener('mousedown',  this.onMouseDown.bind(this), false);
      this.elCanvas.addEventListener('mouseup',    this.onMouseUp.bind(this), false);
      this.elCanvas.addEventListener('mousemove',  this.onMouseMove.bind(this), false);
      this.elCanvas.addEventListener('touchstart', this.onMouseDown.bind(this), false);
      this.elCanvas.addEventListener('touchend',   this.onMouseUp.bind(this), false);
      this.elCanvas.addEventListener('touchmove',  this.onMouseMove.bind(this), false);
   }
   
   onMouseDown(event) {
      const pos = this.getPos(event);
      if (this.distance(pos, {x: this.radius, y: this.radius}) > this.radius * 0.75) {
         this.dragging = 'minute';
         this.moveMinuteHand(pos);
      }
      else if (this.distance(pos, {x: this.radius, y: this.radius}) > this.radius * 0.5) {
         this.dragging = 'hour';
         this.moveHourHand(pos);
      }
      else if (this.distance(pos, {x: this.radius, y: this.radius}) > this.radius * 0.25) {
         this.dragging = 'hour2';
         this.moveHourHand2(pos);
      }

      else this.dragging = false;
   }
   
   onMouseUp(event) {
      this.dragging = false;
   }
   
   onMouseMove(event) {
      event.preventDefault();
      if (this.dragging === 'minute') this.moveMinuteHand(this.getPos(event));
      else if (this.dragging === 'hour') this.moveHourHand(this.getPos(event));
      else if (this.dragging === 'hour2') this.moveHourHand2(this.getPos(event));
   }
   
   moveMinuteHand(pos) {
      const minute = Math.round(this.posToDegrees(pos) / 6) % 60;
      if (minute !== this.minute) {
         this.minute = minute;
         this.draw();
      }
   }
   
   moveHourHand(pos) {
      const hour = Math.round(this.posToDegrees(pos) / 30) % 12;
      if (hour !== this.hour) {
         this.hour = hour;
         this.draw();
      }
   }
   moveHourHand2(pos) {
      let hour = (Math.round(this.posToDegrees(pos) / 30) + 12);
      if (hour === 24) hour = 12;
      if (hour !== this.hour) {
         this.hour = hour;
         this.draw();
      }
   }		
   
   posToDegrees(pos) {
      const radians = Math.atan2(pos.x - this.radius, pos.y - this.radius);
      return (radians * (180 / Math.PI) * -1) + 180;
   }
   
   getPos(event) {

      let pos = {};

      if (event.type.charAt(0) === 't') {
         let touch = event.touches[0];
   
         if (typeof touch === "undefined") return false;
         else {
            const rect = this.elCanvas.getBoundingClientRect();
            pos.x = ((touch.clientX - rect.left) / this.elCanvas.offsetWidth) * this.settings.size;
            pos.y = ((touch.clientY - rect.top) / this.elCanvas.offsetWidth) * this.settings.size;
         }
   
      }
      else {
         pos.x = (event.offsetX / this.elCanvas.offsetWidth) * this.settings.size;
         pos.y = (event.offsetY / this.elCanvas.offsetHeight) * this.settings.size;
      }

      return pos;

   }
   
   distance(p1, p2) {
      const a = p1.x - p2.x;
      const b = p1.y - p2.y;
      return Math.sqrt(a*a + b*b);
   }
   
   draw() {
      this.ctx.clearRect(0, 0, this.elCanvas.width, this.elCanvas.height);        
      this.drawFace();
      this.drawHourHand();
      this.drawMinuteHand();
      this.drawCenter();
      this.elDigital.innerText = ('00' + this.hour).slice(-2) + ':' + ('00' + this.minute).slice(-2) + ' Uhr';
   }
      
   drawFace() {

      // Minutenring
      this.ctx.lineWidth = 1;
      this.ctx.strokeStyle = '#ccc';
      this.ctx.beginPath();
      this.ctx.arc(this.radius, this.radius, this.radius, 0, Math.PI * 2, false);
      this.ctx.fillStyle = this.settings.minuteCircleColor;
      this.ctx.fill();

      // Stundenring 0-11
      this.ctx.beginPath();
      this.ctx.arc(this.radius, this.radius, this.radius*0.75, 0, Math.PI * 2);
      this.ctx.fillStyle = this.settings.hourCircleColor;
      this.ctx.fill();
      this.ctx.stroke();

      // Stundenring 12-23
      this.ctx.beginPath();
      this.ctx.arc(this.radius, this.radius, this.radius*0.5, 0, Math.PI * 2);
      this.ctx.fillStyle = this.settings.hourCircleColor2;
      this.ctx.fill();
      this.ctx.stroke();

      // Mitte
      this.ctx.beginPath();
      this.ctx.arc(this.radius, this.radius, this.radius*0.25, 0, Math.PI * 2);
      this.ctx.fillStyle = this.settings.centerCircleColor;
      this.ctx.fill();
      this.ctx.stroke();

      // Zahlen
      this.ctx.textBaseline = "middle";
      this.ctx.textAlign = "center";				
      
      for (var i = 0; i < 12; i++) {
         const angle = (i - 3) * (Math.PI * 2) / 12;
         this.ctx.beginPath();

         let posNumber = this.getPointFromAngle(angle, this.radius*.625);
         this.ctx.fillStyle = this.settings.hourNumberColor;
         this.ctx.font =  .14 * this.radius + 'px sans-serif';				
         this.ctx.fillText(i, posNumber.x, posNumber.y);

         this.ctx.fillStyle = this.settings.hourNumberColor2;
         this.ctx.font =  .12 * this.radius + 'px sans-serif';
         posNumber = this.getPointFromAngle(angle, this.radius*.37);
         this.ctx.fillText(i+12, posNumber.x, posNumber.y);				
      }
      
      // Minutenskala und Zahlen
      this.ctx.font =  .14 * this.radius + 'px sans-serif';
       
      for (var i = 0; i < 60; i+=5) {
         const angle = (i - 15) * (Math.PI * 2) / 60;
         this.ctx.fillStyle = this.settings.minuteNumberColor;
         const posNumber = this.getPointFromAngle(angle, this.radius*.88);
         this.ctx.fillText(i, posNumber.x, posNumber.y);
      }
       
   }
   
   drawCenter() {
      this.ctx.beginPath();
      this.ctx.arc(this.radius, this.radius, this.radius*0.013, 0, Math.PI * 2);
      this.ctx.lineWidth = this.radius * .02;
      this.ctx.strokeStyle = '#000';
      this.ctx.stroke();
   }

   drawHourHand() {
      if (this.hour < 12) {
         const angle = ((Math.PI * 2) * (this.hour / 12)) - Math.PI / 2;
         this.hourTip = this.drawHand(angle, this.radius * .625, this.settings.hourHandColor, this.radius*.04);
      }
      else {
         const angle = ((Math.PI * 2) * (this.hour / 12)) - Math.PI / 2;
         this.hourTip = this.drawHand(angle, this.radius * .375, this.settings.hourHandColor, this.radius*.04);
      }
   }

   drawMinuteHand() {
      const angle = ((Math.PI * 2) * (this.minute / 60)) - Math.PI / 2;
      this.minuteTip = this.drawHand(angle, this.radius * .875, this.settings.minuteHandColor, this.radius*.03);
   }

   drawHand(angle, center, color, lineWidth) {
      let pos = this.getPointFromAngle(angle, center);
      let pos2 = this.getPointFromAngle(angle, center-this.radius*.14);
      this.ctx.beginPath();
      this.ctx.arc(pos.x, pos.y, this.radius*0.125, 0, Math.PI * 2);
      this.ctx.globalAlpha = .3;
      this.ctx.fillStyle = this.settings.selectedColor;
      this.ctx.strokeStyle = this.settings.selectedColor;			
      this.ctx.fill();
      this.ctx.lineWidth = 2;
      this.ctx.stroke();

      this.ctx.beginPath();
      this.ctx.moveTo(this.radius, this.radius);
      this.ctx.lineTo(pos2.x, pos2.y);
      this.ctx.lineWidth = 8;
      this.ctx.lineCap = 'round';
      this.ctx.stroke(); 


      this.ctx.globalAlpha = 1;
   }
   
   getPointFromAngle(angle, centerDistance) {
      return {
         x: this.radius + Math.cos(angle) * centerDistance,
         y: this.radius + Math.sin(angle) * centerDistance
      };
   }
   
   getElement() { return this.elMain; }
   
}